import DOMPurify from 'dompurify';

export const sanitizeHTML = (dirty) => ({
  __html: DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'br', 'p', 'span', 'ul', 'ol', 'li', 'a', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'img', 'sup', 'sub'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'src', 'alt', 'width', 'height'],
  })
});
